var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/product-image.j2"] = require( "macros/product-image.j2" );
dependencies["macros/mto-image.j2"] = require( "macros/mto-image.j2" );
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/header/cart-confirm-image.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/product-image.j2", false, "core/templates/header/cart-confirm-image.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("productImage")) {
var t_4 = t_1.productImage;
} else {
cb(new Error("cannot import 'productImage'")); return;
}
context.setVariable("productImage", t_4);
if(t_1.hasOwnProperty("productImageSrc")) {
var t_5 = t_1.productImageSrc;
} else {
cb(new Error("cannot import 'productImageSrc'")); return;
}
context.setVariable("productImageSrc", t_5);
env.getTemplate("macros/mto-image.j2", false, "core/templates/header/cart-confirm-image.j2", false, function(t_7,t_6) {
if(t_7) { cb(t_7); return; }
t_6.getExported(function(t_8,t_6) {
if(t_8) { cb(t_8); return; }
if(t_6.hasOwnProperty("mtoImage")) {
var t_9 = t_6.mtoImage;
} else {
cb(new Error("cannot import 'mtoImage'")); return;
}
context.setVariable("mtoImage", t_9);
output += "\n";
env.getTemplate("macros/urls.j2", false, "core/templates/header/cart-confirm-image.j2", false, function(t_11,t_10) {
if(t_11) { cb(t_11); return; }
t_10.getExported(context.getVariables(), frame, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
if(t_10.hasOwnProperty("imageUrl")) {
var t_13 = t_10.imageUrl;
} else {
cb(new Error("cannot import 'imageUrl'")); return;
}
context.setVariable("imageUrl", t_13);
output += "\n\n";
if(runtime.contextOrFrameLookup(context, frame, "mto")) {
output += "\n\n    ";
output += runtime.suppressValue((lineno = 6, colno = 13, runtime.callWrap(t_9, "mtoImage", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"imageUrl"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"imageSlug"),runtime.makeKeywordArgs({"preset": runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"imagePresets")),"mtoCartConfirmImagePreset"),"fit": runtime.contextOrFrameLookup(context, frame, "None"),"altText": runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"displayName"),"class": "c-cart-confirm__img c-mto-cart-confirm__img","disableZoom": true,"quality": runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"experience")),"image_quality")})])), env.opts.autoescape);
output += "\n\n";
;
}
else {
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"imageId")) {
output += "\n\n    ";
output += runtime.suppressValue((lineno = 19, colno = 17, runtime.callWrap(t_4, "productImage", context, [(lineno = 20, colno = 16, runtime.callWrap(t_13, "imageUrl", context, [])),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"imageStyle"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"colorCode"),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"imageId"),runtime.makeKeywordArgs({"imageHeight": 300,"altText": runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"cart")),"confirmViewModel")),"displayName"),"class": "c-cart-confirm__img","disableZoom": true})])), env.opts.autoescape);
output += "\n\n";
;
}
else {
output += "\n\n    ";
var t_14;
t_14 = (lineno = 32, colno = 41, runtime.callWrap(t_5, "productImageSrc", context, [(lineno = 32, colno = 50, runtime.callWrap(t_13, "imageUrl", context, [])),runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"constants")),"thirdParty")),"default")),"scene7")),"tile_placeholder_image_small")]));
frame.set("noDefaultImage", t_14, true);
if(frame.topLevel) {
context.setVariable("noDefaultImage", t_14);
}
if(frame.topLevel) {
context.addExport("noDefaultImage", t_14);
}
output += "\n\n    <div class=\"c-cart-confirm__img\">\n\n        <img src=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "noDefaultImage"), env.opts.autoescape);
output += "\" />\n\n    </div>\n\n";
;
}
;
}
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/header/cart-confirm-image.j2"] , dependencies)